// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvi_redeem_augeo {
    /* display: flex;
      flex-wrap: wrap; */
    height: 100vh;
  }
  .redeem_right {
    position: relative;
  }
  .redeem_left,
  .redeem_right {
    max-width: 50%;
    width: 100%;
    flex: 0 0 auto;
  }
  .redeem_right .redeem_banner img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .redeem_right .redeem_banner {
    height: 100%;
    position: relative;
  }
  
  .redeem_right .redeem_banner:before {
    content: "";
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .redeem_left {
    background: #004aad;
    padding: 50px 0 20px 0;
  }
  
  .redeem_left_inner_augeo {
    max-width: 400px;
    width: 100%;
    padding: 30px 20px;
    margin: 0 auto;
  }
  
  .redeem__form {
    text-align: center;
  }
  .redeem__form label {
    font-size: 17px;
    color: #fff;
    margin-top: 10px;
  }
  
  .redeem__field {
    height: 45px;
    border: 0;
    border-radius: 0px;
    background-color: #fff;
    padding: 0 10px;
    color: #1c1c1c;
    text-align: center;
  }
  
  .redeem__field::placeholder {
    color: #1c1c1c;
  }
  
  .redeem__field:focus,
  .redeem__field:hover {
    outline: 0px;
    box-shadow: none;
  }
  
  .redeem_submit button {
    display: block;
    width: 100%;
    margin-top: 40px;
    color: #1c1c1c;
    font-weight: 600;
    border-radius: 0px;
    border: 0px;
    height: 50px;
    line-height: 50px;
    padding: 0px;
    background: #ffdf2b;
    text-transform: uppercase;
  }
  
  .redeem_top_text {
    position: absolute;
    top: 40px;
    width: 100%;
    text-align: center;
    padding: 0 50px;
  }
  
  .cert_trav {
    background: #fff;
    width: 100%;
    padding: 20px;
    border: 4px solid #ffdf2b;
    margin-top: 40px;
  }
  
  .cert_trav h2 {
    font-size: 32px;
    color: #1c1c1c;
    line-height: 42px;
    font-weight: 600;
  }
  
  .cert_trav p {
    font-size: 16px;
    color: #1c1c1c;
    line-height: 24px;
  }
  
  .redeem_top_text h3 {
    font-size: 44px;
    color: #fff;
    font-weight: 600;
    margin-top: 40px;
    font-style: italic;
  }
  
  .redeem_top_text h3 span {
    color: #ffdf2b;
  }
  
  .thank_you_page_augeo {
    background: #004aad;
    height: 100%;
  }
  
  .thank_you_inner_sec {
    padding: 30px 20px;
  
    margin: 0 auto;
  }
  
  .tvi_logo {
    text-align: center;
    margin-bottom: 50px;
  }
  
  .thank_you_inner_sec p {
    text-align: center;
  }
  .thank_you_inner_sec .top_para {
    font-size: 32px;
    color: #ffdf2b;
    line-height: 45px;
    font-weight: 600;
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
  }

  .thank_you_inner_sec .button_section {
    text-align: center;
    margin-top: 40px;
  }

  .button_section button {
    background: #0091f4;
    border: 0px;
    color: #ffffff;
    font-size: 18px;
    padding: 10px 30px;
    border-radius: 8px;
    font-weight: 700;
  }
  
  .thank_you_inner_sec .bottom_para {
    font-size: 32px;
    color: #fff;
    line-height: 45px;
    font-weight: 600;
    max-width: 1000px;
    width: 100%;
    margin: 40px auto 0 auto;
  }
  @media screen and (max-width: 1300px) {
    .redeem_right .redeem_banner {
      height: 100%;
    }
    .redeem_top_text h3 {
      font-size: 36px;
    }
  }
  
  @media screen and (max-width: 991px) {
    .redeem_left,
    .redeem_right {
      max-width: 100%;
    }
    .redeem_left {
      order: 2;
      height: auto;
    }
    .redeem_right {
      order: 1;
      height: 500px;
    }
    .redeem_top_text h3 {
      font-size: 32px;
    }
    .redeem_top_text img {
      width: 30%;
    }
    .tvi_redeem_augeo {
      height: auto;
    }
    .thank_you_page_augeo {
      background: #004aad;
      height: 100%;
    }
    .tvi_logo img {
      max-width: 40%;
      width: 100%;
    }
    .thank_you_inner_sec .top_para {
      font-size: 28px;
      line-height: 34px;
    }
    .thank_you_inner_sec .bottom_para {
      font-size: 26px;
      line-height: 34px;
    }
  }
  
  @media screen and (max-width: 576px) {
    .redeem_top_text img {
      width: 40%;
    }
    .cert_trav h2 {
      font-size: 18px;
      line-height: 24px;
    }
    .cert_trav p {
      font-size: 14px;
    }
    .redeem_top_text h3 {
      font-size: 19px;
    }
    .redeem_right {
      height: 400px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/augeo-redeem/augeo-redeem.css"],"names":[],"mappings":"AAAA;IACI;wBACoB;IACpB,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,cAAc;IACd,WAAW;IACX,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;;IAElB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,wBAAwB;EAC1B;EACA;IACE;MACE,YAAY;IACd;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;;MAEE,eAAe;IACjB;IACA;MACE,QAAQ;MACR,YAAY;IACd;IACA;MACE,QAAQ;MACR,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,UAAU;IACZ;IACA;MACE,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;MACE,cAAc;MACd,WAAW;IACb;IACA;MACE,eAAe;MACf,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,eAAe;MACf,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;IACf;EACF","sourcesContent":[".tvi_redeem_augeo {\n    /* display: flex;\n      flex-wrap: wrap; */\n    height: 100vh;\n  }\n  .redeem_right {\n    position: relative;\n  }\n  .redeem_left,\n  .redeem_right {\n    max-width: 50%;\n    width: 100%;\n    flex: 0 0 auto;\n  }\n  .redeem_right .redeem_banner img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  .redeem_right .redeem_banner {\n    height: 100%;\n    position: relative;\n  }\n  \n  .redeem_right .redeem_banner:before {\n    content: \"\";\n    position: absolute;\n    background: rgba(0, 0, 0, 0.3);\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n  }\n  .redeem_left {\n    background: #004aad;\n    padding: 50px 0 20px 0;\n  }\n  \n  .redeem_left_inner_augeo {\n    max-width: 400px;\n    width: 100%;\n    padding: 30px 20px;\n    margin: 0 auto;\n  }\n  \n  .redeem__form {\n    text-align: center;\n  }\n  .redeem__form label {\n    font-size: 17px;\n    color: #fff;\n    margin-top: 10px;\n  }\n  \n  .redeem__field {\n    height: 45px;\n    border: 0;\n    border-radius: 0px;\n    background-color: #fff;\n    padding: 0 10px;\n    color: #1c1c1c;\n    text-align: center;\n  }\n  \n  .redeem__field::placeholder {\n    color: #1c1c1c;\n  }\n  \n  .redeem__field:focus,\n  .redeem__field:hover {\n    outline: 0px;\n    box-shadow: none;\n  }\n  \n  .redeem_submit button {\n    display: block;\n    width: 100%;\n    margin-top: 40px;\n    color: #1c1c1c;\n    font-weight: 600;\n    border-radius: 0px;\n    border: 0px;\n    height: 50px;\n    line-height: 50px;\n    padding: 0px;\n    background: #ffdf2b;\n    text-transform: uppercase;\n  }\n  \n  .redeem_top_text {\n    position: absolute;\n    top: 40px;\n    width: 100%;\n    text-align: center;\n    padding: 0 50px;\n  }\n  \n  .cert_trav {\n    background: #fff;\n    width: 100%;\n    padding: 20px;\n    border: 4px solid #ffdf2b;\n    margin-top: 40px;\n  }\n  \n  .cert_trav h2 {\n    font-size: 32px;\n    color: #1c1c1c;\n    line-height: 42px;\n    font-weight: 600;\n  }\n  \n  .cert_trav p {\n    font-size: 16px;\n    color: #1c1c1c;\n    line-height: 24px;\n  }\n  \n  .redeem_top_text h3 {\n    font-size: 44px;\n    color: #fff;\n    font-weight: 600;\n    margin-top: 40px;\n    font-style: italic;\n  }\n  \n  .redeem_top_text h3 span {\n    color: #ffdf2b;\n  }\n  \n  .thank_you_page_augeo {\n    background: #004aad;\n    height: 100%;\n  }\n  \n  .thank_you_inner_sec {\n    padding: 30px 20px;\n  \n    margin: 0 auto;\n  }\n  \n  .tvi_logo {\n    text-align: center;\n    margin-bottom: 50px;\n  }\n  \n  .thank_you_inner_sec p {\n    text-align: center;\n  }\n  .thank_you_inner_sec .top_para {\n    font-size: 32px;\n    color: #ffdf2b;\n    line-height: 45px;\n    font-weight: 600;\n    max-width: 900px;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  .thank_you_inner_sec .button_section {\n    text-align: center;\n    margin-top: 40px;\n  }\n\n  .button_section button {\n    background: #0091f4;\n    border: 0px;\n    color: #ffffff;\n    font-size: 18px;\n    padding: 10px 30px;\n    border-radius: 8px;\n    font-weight: 700;\n  }\n  \n  .thank_you_inner_sec .bottom_para {\n    font-size: 32px;\n    color: #fff;\n    line-height: 45px;\n    font-weight: 600;\n    max-width: 1000px;\n    width: 100%;\n    margin: 40px auto 0 auto;\n  }\n  @media screen and (max-width: 1300px) {\n    .redeem_right .redeem_banner {\n      height: 100%;\n    }\n    .redeem_top_text h3 {\n      font-size: 36px;\n    }\n  }\n  \n  @media screen and (max-width: 991px) {\n    .redeem_left,\n    .redeem_right {\n      max-width: 100%;\n    }\n    .redeem_left {\n      order: 2;\n      height: auto;\n    }\n    .redeem_right {\n      order: 1;\n      height: 500px;\n    }\n    .redeem_top_text h3 {\n      font-size: 32px;\n    }\n    .redeem_top_text img {\n      width: 30%;\n    }\n    .tvi_redeem_augeo {\n      height: auto;\n    }\n    .thank_you_page_augeo {\n      background: #004aad;\n      height: 100%;\n    }\n    .tvi_logo img {\n      max-width: 40%;\n      width: 100%;\n    }\n    .thank_you_inner_sec .top_para {\n      font-size: 28px;\n      line-height: 34px;\n    }\n    .thank_you_inner_sec .bottom_para {\n      font-size: 26px;\n      line-height: 34px;\n    }\n  }\n  \n  @media screen and (max-width: 576px) {\n    .redeem_top_text img {\n      width: 40%;\n    }\n    .cert_trav h2 {\n      font-size: 18px;\n      line-height: 24px;\n    }\n    .cert_trav p {\n      font-size: 14px;\n    }\n    .redeem_top_text h3 {\n      font-size: 19px;\n    }\n    .redeem_right {\n      height: 400px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
